import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { clone } from 'ramda';
import { AsyncCreatable } from 'react-select';
import { getMaterialsList } from "../../api/task";
import fields from "./fields";
import Input from '../Input';
import Currency from '../Currency';
import styles from './styles';

export default class MaterialItem extends Component {
  state = {
    fields: clone(fields),
  };

  constructor(props) {
    super(props);
    this.removeItem = this.removeItem.bind(this);
    this.changeField = this.changeField.bind(this);
  }

  removeItem(e) {
    e.preventDefault();
    this.props.onChange('delete');
  }

  changeField(field, value) {
    this.props.onChange(field, value);
  }

  render() {
    const { name, material_id, quantity, unit_of_measure, price, subtotal } = this.props.material;
    const disabled = this.props.disabled;
    const finFieldsVisible = this.props.financialFieldsVisible;
    const finFieldsDisabled = this.props.financialFieldsDisabled || disabled;
    const isCustom = !material_id && this.props.isRemovable;

    return (
      <div className="row">
        <div className={finFieldsVisible ? "col col-lg-5 col-md-4 col-sm-4" : "col col-9"}>
          <AsyncCreatable
            cacheOptions
            defaultOptions
            clearable={false}
            placeholder='Choose material...'
            loadOptions={(filter) => getMaterialsList(filter, this.props.vendors)}
            onChange={(newItem) => {
              this.changeField('material', newItem)}
            }
            value={name ? {
              label: name,
              value: material_id
            } : null}
            disabled={disabled}
          />
        </div>
        <div className="col col-lg-1 col-md-2 col-sm-2">
          <Input
            field={{ ...this.state.fields.quantity, value: quantity }}
            onChange={(name, field) => this.changeField('quantity', field.value)}
            disabled={disabled}
          />
        </div>
        <div className="col col-1">
          {!isCustom && (<div className="p-2">{unit_of_measure}</div>)}
          {isCustom && (<Input
            field={{ ...this.state.fields.unit_of_measure, value: unit_of_measure }}
            onChange={(name, field) => this.changeField('unit_of_measure', field.value)}
            disabled={disabled}
          />)}
        </div>
        {finFieldsVisible && <div className="col col-2">
          <Currency
            forceUpdate
            field={{ ...this.state.fields.price, value: price }}
            onChange={(name, field) => this.changeField('price', field.value)}
            disabled={finFieldsDisabled}
          />
        </div>}
        {finFieldsVisible && <div className="col col-2">
          <Currency
            forceUpdate
            disabled
            field={{ ...this.state.fields.subtotal, value: subtotal }}
          />
        </div>}
        {
          !disabled && (this.props.isRemovable ?(
            <div className="col col-1 d-flex align-items-center">
              <button className="btn ui-btn" style={styles.removeBtn} onClick={this.removeItem}>
                <i className="material-icons">clear</i>
              </button>
            </div>
          ) : (
            <div className="col col-1 d-flex align-items-center">
              &nbsp;
            </div>
          ))
        }
      </div>
    );
  }
}

MaterialItem.propTypes = {
  isRemovable: PropTypes.bool,
  material: {
    id: PropTypes.number,
    material_id: PropTypes.number,
    name: PropTypes.string,
    quantity: PropTypes.number,
    price: PropTypes.string,
    subtotal: PropTypes.string,
  },
  onChange: PropTypes.func,
  vendors: PropTypes.array,
  financialFieldsVisible: PropTypes.bool,
  financialFieldsDisabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/common/Materials/item.js